import { render } from "./IndexedByGoogle.vue?vue&type=template&id=6ba181ef&scoped=true"
import script from "./IndexedByGoogle.vue?vue&type=script&lang=js"
export * from "./IndexedByGoogle.vue?vue&type=script&lang=js"

import "./IndexedByGoogle.vue?vue&type=style&index=0&id=6ba181ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba181ef"]])

export default __exports__